export const AlignCenterIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width="16"
    height="16"
    className={className}
    style={{ display: "block" }}
  >
    <path
      d="M7.33333 14.6654V11.332H4V9.33203H7.33333V6.66536H2V4.66536H7.33333V1.33203H8.66667V4.66536H14V6.66536H8.66667V9.33203H12V11.332H8.66667V14.6654H7.33333Z"
      fill="#1A2547"
    />
  </svg>
);
